export const ERROR = "ERROR";


export const CREATE_NEW_USER_Signup = "CREATE_NEW_USER_Signup";
export const LOGIN_USER = "LOGIN_USER";
export const ChangePassword = "ChangePassword";
export const FOREGT_PASSWORD = "FOREGT_PASSWORD";
export const GET_USER_PROFULE = "GET_USER_PROFULE";
export const UPDATE_USER_PROFULE = "UPDATE_USER_PROFULE";

export const CREATE_EMP = "CREATE_EMP";
export const ALL_EMP = "ALL_EMP";
export const ADMIN_UPDATE_EMP = "ADMIN_UPDATE_EMP";
export const All_Const = "All_Const";

export const CREATE_CATEGORIES = "CREATE_CATEGORIES";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const CREATE_CARS = "CREATE_CARS";
export const GETALL_CARS = "GETALL_CARS";
export const GETCARBYID = "GETCARBYID";
export const GETALL_CATEGORIES = "GETALL_CATEGORIES";
export const UPDATE_CARS = "UPDATE_CARS";
export const DELETE_CARS = "DELETE_CARS";

export const CREACTE_APPLICATION = "CREACTE_APPLICATION";
export const GET_ALL_APPLICATION = "GET_ALL_APPLICATION";
export const GET_APPLICATION_DATA = "GET_APPLICATION_DATA";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const UPDATE_STATUE = "UPDATE_STATUE";
export const GET_COMMENTS = "GET_COMMENTS";
export const SUBMIT_DOC = "SUBMIT_DOC";
export const CREACTE_CONSULTANT_APPLICATION = "CREACTE_CONSULTANT_APPLICATION";

export const ADD_PAYMENT = "ADD_PAYMENT";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
export const DELETE_PAYMENT = "DELETE_PAYMENT";
export const GET_PAYMENT = "GET_PAYMENT";
export const GET_ALL_PAYMENT = "GET_ALL_PAYMENT";

export const ADD_TOURISTTYPE = "ADD_TOURISTTYPE";
export const UPDATE_TOURISTTYPE = "UPDATE_TOURISTTYPE";
export const DELETE_TOURISTTYPE = "DELETE_TOURISTTYPE";
// export const GET_TOURISTTYPE = "GET_TOURISTTYPE";
export const GET_ALL_TOURISTTYPE = "GET_ALL_TOURISTTYPE";

export const CREATE_CONTACT = "CREATE_CONTACT";

export const CREATE_SLIDE = "CREATE_SLIDE";
export const DELETE_SLIDE = "DELETE_SLIDE";
export const UPDATE_SLIDE = "UPDATE_SLIDE";
export const GET_SLIDE = "GET_SLIDE";

